import { createContext, FC, ReactNode, useContext } from 'react'

/**
 * Optional side-channel reporting the *actual* selected sensors of an embedded
 * time-series chart (the chart owns its selection internally — e.g. tags added
 * via its own tag-search / pen drawer — which the tab's `sensorIds` history item
 * does not reflect). An embedder (e.g. the Dossiers page) wraps the viewer in a
 * {@link TimeSeriesSensorsListenerProvider} to observe those sensors for logging.
 *
 * Read-only: the listener must not mutate viewer/chart state.
 */
export type TimeSeriesSensorsListener = (sensorIds: string[]) => void

const TimeSeriesSensorsListenerContext = createContext<
  TimeSeriesSensorsListener | undefined
>(undefined)

export const TimeSeriesSensorsListenerProvider: FC<{
  listener: TimeSeriesSensorsListener
  children: ReactNode
}> = ({ listener, children }) => (
  <TimeSeriesSensorsListenerContext.Provider value={listener}>
    {children}
  </TimeSeriesSensorsListenerContext.Provider>
)

export const useTimeSeriesSensorsListener = ():
  | TimeSeriesSensorsListener
  | undefined => useContext(TimeSeriesSensorsListenerContext)
